/*
  Efeito "produto se abrindo" — hover no desktop, scroll/visibilidade no mobile e na
  página de produto. Ver assets/product-reveal.css para o CSS correspondente.
*/
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function setupCardReveal() {
    var cards = document.querySelectorAll('.product-card__reveal[data-reveal]');
    if (!cards.length) return;

    if (hoverCapable || reducedMotion) {
      // Desktop: pure CSS :hover handles it, nothing to wire up in JS.
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-open', entry.isIntersecting);
        });
      },
      { threshold: 0.5 }
    );

    cards.forEach(function (card) {
      io.observe(card);
    });
  }

  function setupScrollReveal() {
    var targets = document.querySelectorAll('[data-reveal-scroll]');
    if (!targets.length || reducedMotion) return;

    var ticking = false;

    function updateAll() {
      var vh = window.innerHeight;

      targets.forEach(function (target) {
        var rect = target.getBoundingClientRect();
        var start = vh * 0.95;
        var end = vh * 0.35;
        var progress = (start - rect.top) / (start - end);
        progress = Math.min(1, Math.max(0, progress));
        target.style.setProperty('--reveal-progress', progress.toFixed(3));
      });

      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(updateAll);
          ticking = true;
        }
      },
      { passive: true }
    );
    window.addEventListener('resize', updateAll);

    updateAll();
  }

  function setupTableReveal() {
    var tables = document.querySelectorAll('.tp-table');
    if (!tables.length) return;

    if (reducedMotion) {
      tables.forEach(function (table) {
        table.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.25 }
    );

    tables.forEach(function (table) {
      io.observe(table);
    });
  }

  function init() {
    setupCardReveal();
    setupScrollReveal();
    setupTableReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run for content swapped in dynamically (Shopify Section Rendering API,
  // quick-buy drawers, infinite scroll collections, etc.).
  document.addEventListener('shopify:section:load', init);
})();
